import { ReactElement, memo } from 'react'
import { Navigate, PathRouteProps, useLocation } from 'react-router-dom'

import {
  persistChatIdToOpenToLocalStorage,
  persistChatModalOpenToLocalStorage,
  persistUrlDataToLocalStorage,
  retrieveUrlDataFromLocalStorage,
} from '@shared/utils'

interface PrivateRouteProps extends PathRouteProps {
  isAuthenticated: boolean
  children: ReactElement
}

const PrivateRoute = ({ isAuthenticated, children }: PrivateRouteProps) => {
  const location = useLocation()
  const { pathname, search } = retrieveUrlDataFromLocalStorage()

  if (isAuthenticated) {
    if (pathname && pathname !== location.pathname) {
      return <Navigate replace to={`${pathname}${search || ''}`} />
    }
    return children
  }

  if (!['/sign-in', '/plus/hub'].includes(window.location.pathname) || window.location.search?.length) {
    persistUrlDataToLocalStorage()
  }

  if (location?.search?.includes('chat-modal-open')) {
    persistChatModalOpenToLocalStorage()
  }
  if (location?.search?.includes('chat-id-to-open')) {
    const splittedSearch = location.search.split('=')
    if (splittedSearch[1]) {
      persistChatIdToOpenToLocalStorage(splittedSearch[1])
    }
  }

  return <Navigate replace to="/sign-in" />
}

export default memo(PrivateRoute)
